module.exports = __webpack_public_path__ + "media/assets/images/car_icon_kokusan-af8bd21d499dec4ddd742249cd6c3147.png";